import React from 'react'
import { MapContainer, TileLayer, LayersControl, ZoomControl } from "react-leaflet";
import { useSelector } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';
import CustomTileLayer from '../../components/CustomTileLayer/CustomTileLayer';
import ControlsContainer from '../../components/ControlsContainer/ControlsContainer';
import Palette from '../../components/Palette/Palette';
import Header from '../../components/Header/Header';
import FlyTo from '../../components/FlyTo/FlyTo';
import '../../style.css';
import './Map.css';
import baseLayers from './baseLayers.json'

const { BaseLayer, Overlay } = LayersControl;

const Map = () => {
  const isPlaying = useSelector(state => state.map.isPlaying);
  const frame = useSelector(state => state.map.frame);
  const spanHours = useSelector(state => state.map.spanHours);
  const isLoading = useSelector(state => state.map.isLoading);

  let id;

  const hasId = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    id = urlParams.get('id');
    return id;
  }

  return (
    <MapContainer
      center={[44.66, -103.85]}
      zoom={hasId() !== null ? 9 : 3}
      minZoom={3}
      scrollWheelZoom={'center'}
      dragging={hasId() !== null ? false : true}
      style={{ height: '100vh' }}
      zoomControl={false}
      doubleClickZoom={false}
    >
      <LayersControl>
        {baseLayers.layers.map((layer, idx) =>
        (
          <BaseLayer checked={idx === 0 ? true : false} name={layer.name} key={layer.name}>
            <TileLayer
              url={layer.url}
              attribution={layer.attribution}
            />
          </BaseLayer>
        )
        )},
        <Overlay name={'Labels'} checked>
          <TileLayer
            url={'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-hybrid/{z}/{x}/{y}{r}.png'}
            attribution={`Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors`}
          />
        </Overlay>
      </LayersControl>
      <CustomTileLayer isPlaying={isPlaying} frame={frame} spanHours={spanHours} />
      <ZoomControl position={'topleft'} style={{ top: '10vh' }} />
      {isLoading ? <LinearProgress style={{ top: '-18px', zIndex: 999 }} /> : null}
      <FlyTo />
      <Header />
      <ControlsContainer />
      <Palette />
    </MapContainer>
  )
}

export default Map
